export default "__VITE_ASSET__KjGMpPZk__"